import { Share } from "components";
import { useMemo } from "react";
import { Text } from '@chakra-ui/react';
import { Divider } from '@chakra-ui/react';

export const CollaborationLevelShare = ({ shareTokens, team }) => {
  const tokens = useMemo(() => 
    shareTokens?.filter(({ permission }) => permission === 'collaboration'
  ), [ shareTokens ]);

  return (
    <>
      {tokens?.map((token: any, index: number) => (
        <div key={token.id}>
          <Share token={token} title="Collaborate" team={team}>
            <Text size="sm">A team member with this link can view assets in this pack as well as add, edit and delete their assets.</Text>
          </Share>
          {tokens.length > 1 && index !== tokens.length-1 && <Divider mt="20px" mb="20px" />}
        </div>
      ))}
    </>
  )
};
